import Icon from '../components/Icon.vue'

Icon.register({
  'low-vision': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M569.3 231.6c3.7 6.2 6.7 17.1 6.7 24.4s-3 18.1-6.7 24.4c-32 54.3-79.6 98.3-136.8 126.3l0 0 43.1 58.4c7.6 10.9 5 25.8-5.9 33.4l-13.1 9.2c-10.9 7.6-25.8 5-33.4-5.9l-251.8-356.5c-11.2 5.1-28.6 14.8-38.8 21.6l190 271.4c-9.5 1-25 1.8-34.6 1.8-12.3 0-32.1-1.3-44.3-3l-40.6-58h0l-119.4-170.6c-8.6 9.3-21.3 25.3-28.3 35.9l124.2 177.4c-73.1-25.5-134.4-76-172.9-141.3-9-15.2-8.8-33.9 0-48.7 0 0 0 0 0 0 33.5-56.9 82.8-99.9 136.8-126.2l-43.1-58.4c-7.6-10.9-5-25.8 5.9-33.4l13.1-9.2c10.9-7.6 25.8-5 33.4 5.9l52.8 72.2c26.3-6.8 54-10.4 82.5-10.4 119.8 0 225 63.9 281.3 159.6zM390 345.9c21.1-24 34-55.4 34-89.9 0-75.2-60.8-136-136-136-17.5 0-34.2 3.3-49.6 9.3l19.1 27.2c26-8 54.8-5.6 79.5 7.7h0c-23.7 0-42.8 19.2-42.8 42.8 0 23.5 19 42.8 42.8 42.8 23.6 0 42.8-19.2 42.8-42.8v0c18.9 35.3 15.9 79.1-8.8 111.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/low-vision.js
// module id = 1536
// module chunks = 0